import type { useStore } from "../../lib/store";

/**
 * Grava só os eixos que mudaram.
 *
 * O comando é por eixo (§19.4) e `optionId: null` limpa a escolha, então
 * "Não informada" não é uma opção do catálogo: é a ausência dela. Repetir a
 * gravação de um eixo intocado criaria auditoria de uma decisão que ninguém
 * tomou.
 */
export async function salvaClassificacoes(
  store: ReturnType<typeof useStore>,
  leadId: string,
  antes: Record<string, string>,
  depois: Record<string, string>,
) {
  for (const definitionId of new Set([...Object.keys(antes), ...Object.keys(depois)])) {
    const anterior = antes[definitionId] ?? "";
    const atual = depois[definitionId] ?? "";
    if (anterior === atual) continue;
    await store.setLeadClassification({
      leadId,
      definitionId,
      optionId: atual || null,
    });
  }
}
